<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Avtomobillərin texniki baxışı</h1>
      </div>
      
      <div class="col-12">
        <div class="note">
          <p>"Yol hərəkəti haqqında" Azərbaycan Respublikası Qanununun əsasən avtobuslar, icazə verilən maksimum kütləsi 3,5 tondan artıq olan yük avtonəqliyyat vasitələri, təhlükəli yüklərin daşınması üçün xüsusi təyinatlı texniki təhlükəsizlik üzrə uyğunluq sertifikatı olan nəqliyyat vasitələri ildə 1 dəfə texniki baxışdan keçməlidirlər.</p>

          <p>Mühərrikinin işçi həcmi 50 kub/sm və daha çox, konstruktiv maksimal sürəti saatda 50 kilometrdən artıq olan bütün tipli, markalı və modelli mexaniki nəqliyyat vasitələri istehsal olunduqları vaxtdan 4 il keçdikdə 2 ildə bir dəfə, istehsal olunduqları vaxtdan 10 il keçdikdə ildə 1 dəfə texniki baxışdan keçməlidirlər.</p>

          <p>Avtomobilinizin istehsal ilini kalkulyatora daxil edərək növbəti texniki baxış müddətləri hasablaya bilərsiniz:</p>
        </div>
      </div>      

      <div class="col-md-6">
        <p>Avtomobilin istehsal ili:</p>
        <input type="number" v-model="year" @input="calc">
      </div>

      <div class="col-md-6">
        <p>Növbəti texniki baxış müddətləri:</p>
        <input type="text" v-model="inspection" disabled>
      </div>
      
      <div class="col-12">
        <div class="note">
          <p>Nəqliyyat vasitələrinin illik texniki baxışdan keçirilməsinə görə:</p>
          <ul>
            <li>аvtonəqliyyаt vаsitələri üçün - 20 mаnаt;</li>
            <li>motonəqliyyat vasitələri, traktor, tikintidə, meşə və kənd təsərrüfatında, başqa işlərdə istifadə üçün nəzərdə tutulan özügedən maşınlar, texnoloji, yarış məqsədli idman və digər mexaniki nəqliyyat vasitələri, qoşqular, yarımqoşqular üçün - 10 mаnаt.</li>
          </ul>
          <p>Növbəti texniki baxışın keçiriləcəyi gün əvvəlki texniki baxışın keçirildiyi gündən hesablanır. Nəqliyyat vasitəsinin növbəti texniki baxışının keçiriləcəyi gündən 20 gün ərzində texniki baxışdan keçirilməməsi Azərbaycan Respublikasının İnzibati Xətalar Məcəlləsi ilə müəyyən edilmiş qaydada məsuliyyətə səbəb olur (50 manat məbləğində cərimə).</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script> 
  export default {
    data(){
      return {
        year: '',
        inspection: []
      }
    },
    methods: {
      calc: function(){

        let currentYear = (new Date()).getFullYear();
        
        this.year = +this.year;

        this.inspection = [];

        if(this.year + 5 >= currentYear){
          this.inspection.push(' ' + (this.year + 5));
        }
        if(this.year + 7 >= currentYear){
          this.inspection.push(' ' + (this.year + 7));
        }
        if(this.year + 9 >= currentYear){
          this.inspection.push(' ' + (this.year + 9));
        }
        
        for( let i = this.year + 10; i < currentYear + 5; i++ ){
          if(i >= currentYear){
            this.inspection.push(' ' + i);
          }
        }

      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/calc/Inspection.vue